import styled from 'styled-components';

import { COLORS, ANIM } from '../../theme/tokens';
import { Text } from '../Text/Text';

export type BadgeColor = 'magenta' | 'green' | 'muted' | 'subtle';

export const BADGE_COLORS: Record<BadgeColor, { bg: string; fg: string }> = {
  magenta: { bg: COLORS.badgeMagentaBg, fg: COLORS.badgeMagenta },
  green: { bg: COLORS.badgeGreenBg, fg: COLORS.badgeGreen },
  muted: { bg: COLORS.surfaceMuted, fg: COLORS.textMuted },
  subtle: { bg: COLORS.pageBg, fg: COLORS.textMuted },
};

export const Root = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 48px;
  padding: 0 14px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 15px;
  background: ${(p) => (p.$active ? COLORS.surfaceMuted : 'transparent')};
  color: ${(p) => (p.$active ? COLORS.text : COLORS.textMuted)};
  transition: background ${ANIM.INTERACT_MS}ms ease, color ${ANIM.INTERACT_MS}ms ease;
`;

export const TabLabel = styled(Text)`
  line-height: 1;
`;

/* A remote monochrome glyph (e.g. a studio menu icon) rendered via CSS mask, recoloured to the tab's
   own text colour so it follows the active/idle state — the same technique as the side-menu MaskIcon. */
export const TabMaskIcon = styled.span<{ $src: string }>`
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  background-color: currentColor;
  -webkit-mask: url(${(p) => p.$src}) center / contain no-repeat;
  mask: url(${(p) => p.$src}) center / contain no-repeat;
`;

export const Count = styled.span<{ $bg: string; $fg: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 600;
  background: ${(p) => p.$bg};
  color: ${(p) => p.$fg};
`;